module.exports = __webpack_public_path__ + "static/media/symbols-bg-photo.2bfc3fa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/symbols-bg-photo.jpg
// module id = 1128
// module chunks = 0